import React from 'react';

type ClassificationEmptyStateProps = {
    title: string;
    description: string;
    actionLabel?: string;
    onAction?: () => void;
};

const ClassificationEmptyState: React.FC<ClassificationEmptyStateProps> = ({
    title,
    description,
    actionLabel,
    onAction
}) => (
    <div className="classification-empty-state">
        <div className="classification-empty-state__icon" aria-hidden="true">
            <i className="far fa-folder-open"></i>
        </div>
        <p className="classification-empty-state__title">{title}</p>
        <p className="classification-empty-state__description">{description}</p>
        {onAction ? (
            <button type="button" className="btn btn-primary classification-empty-state__action" onClick={onAction}>
                {actionLabel}
            </button>
        ) : <></>}
    </div>
);

export default ClassificationEmptyState;
